module.exports = __webpack_public_path__ + "media/PAG58-02.a557ede3.mp3";